/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Staples_AddInputs */

const en_staples_add = /** @type {(inputs: Staples_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a staple`)
};

const de_staples_add = /** @type {(inputs: Staples_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorrat hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add a staple" |
*
* @param {Staples_AddInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const staples_add = /** @type {((inputs?: Staples_AddInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Staples_AddInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_staples_add(inputs)
	return en_staples_add(inputs)
});